import React, { useState } from "react";
import ".././popup.common.css";
import CustomModal from "../../Modal/CustomModal";
import PasswordForMembership from "./PasswordForMembership";
import SkipPasswordForMembership from "./SkipPasswordForMembership";
import ResetPasswordForMembership from "./ResetPasswordForMembership";

const MembershipPasswordPopup = ({
	onClose,
	onCancel,
	onSkip,
	onSubmitted,
	onResetSuccess,
	membershipId,
	membershipUserId = null,
	startWithReset = false,
	shouldContinueAfterReset = true,
	initialResetFlowMode = "knows",
	hideResetPassword = false,
}) => {
	const [showPasswordForMembership, setShowPasswordForMembership] = useState(!startWithReset);
	const [showSkipPasswordForMembership, setShowSkipPasswordForMembership] = useState(false);
	const [showResetPasswordForMembership, setShowResetPasswordForMembership] = useState(
		!!startWithReset
	);

	const showSkipStep = () => {
		setShowPasswordForMembership(false);
		setShowResetPasswordForMembership(false);
		setShowSkipPasswordForMembership(true);
	};

	const showResetStep = () => {
		setShowPasswordForMembership(false);
		setShowResetPasswordForMembership(true);
		setShowSkipPasswordForMembership(false);
	};

	const showPasswordStep = () => {
		setShowPasswordForMembership(true);
		setShowResetPasswordForMembership(false);
		setShowSkipPasswordForMembership(false);
	};

	return (
		<CustomModal show={true} onHide={onClose} hideCloseButton={true}>
			{showPasswordForMembership && (
			<PasswordForMembership
				onClose={onClose}
				onSkip={onSkip}
				onSubmitted={onSubmitted}
				membershipId={membershipId}
				membershipUserId={membershipUserId}
				onShowSkipStep={showSkipStep}
				onShowResetStep={hideResetPassword ? undefined : showResetStep}
				hideResetPassword={hideResetPassword}
			/>
			)}
 
			{showSkipPasswordForMembership && (
			<SkipPasswordForMembership 
				onClose={onClose} 
				onSkip={onSkip} 
				onSubmitted={onSubmitted} 
				membershipId={membershipId}
				onEnterUserPassword={showPasswordStep}
			/>
			)}
			{showResetPasswordForMembership && (
			<ResetPasswordForMembership
				onClose={onClose}
				onSkip={onSkip}
				onSubmitted={onSubmitted}
				onResetSuccess={onResetSuccess}
				shouldContinueAfterReset={shouldContinueAfterReset}
				membershipId={membershipId}
				membershipUserId={membershipUserId}
				initialFlowMode={initialResetFlowMode}
			/>
			)}
		</CustomModal>
	);
};

export default MembershipPasswordPopup;
